export default __webpack_public_path__ + "static/media/img7.dbf3f835.png";